import React, { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import Icon from '~/components/Icon';
import icons from '~/components/Icon/components';

export type Props = {
  dataTestId?: string;
  icon: keyof typeof icons;
} & HTMLAttributes<HTMLButtonElement>;

const IconOnlyButton: React.FC<Props> = ({
  dataTestId,
  icon,
  onClick,
  ...rest
}) => (
  <Container data-testid={dataTestId} onClick={onClick} type="button" {...rest}>
    <Icon name={icon} />
  </Container>
);

const Container = styled.button<{}>(
  ({ theme }) => css`
    background-color: transparent;
    border: none;
    border-radius: ${theme.getTokens().border.radius.s};
    font-size: ${theme.fs('l')};
    cursor: pointer;
    padding: ${theme.space('xxxs')};

    display: flex;
    justify-content: center;
    align-items: center;

    transition: all 0.3s ease;

    &:hover {
      background-color: ${theme.color('grey', 'translucent')};
    }
  `,
);

export default IconOnlyButton;
